/* ============================================================
   SELENA BLAKE — Product gallery (mobile slider + AJAX color swap)
   Versión con fade sutil (sin overlay opaco).
   ============================================================ */

(function () {
  'use strict';

  function init() {
    var cfg = window.SB_PRODUCT_CFG;
    if (!cfg || !cfg.sectionId) return;
    initMobileSlider(cfg.sectionId);
    if (cfg.useVariantsImageGroup) initColorSwap(cfg);
  }

  function initMobileSlider(sectionId) {
    var slider = document.getElementById('sb-slider-' + sectionId);
    var dotsWrap = document.getElementById('sb-dots-' + sectionId);
    if (!slider || !dotsWrap) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('.sb-slide'));
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.sb-dot'));

    function updateActive() {
      var scrollLeft = slider.scrollLeft;
      var current = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].offsetLeft - 10 <= scrollLeft) current = i;
      }
      dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }

    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActive, 60);
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });
    slider.scrollTo({ left: 0, behavior: 'instant' });
  }

  function initColorSwap(cfg) {
    var sectionId = cfg.sectionId;
    var productUrl = cfg.productUrl;
    var variants = cfg.variants || [];
    var optionNames = cfg.optionNames || [];
    var colorTrigger = String(cfg.colorTrigger || 'Color').toLowerCase()
      .split(',').map(function (s) { return s.trim(); });

    var currentVariantId = new URLSearchParams(window.location.search).get('variant');
    var isSwapping = false;

    var colorPos = -1;
    var otherPos = [];
    optionNames.forEach(function (name, i) {
      if (colorTrigger.indexOf(name.toLowerCase()) !== -1) colorPos = i;
      else otherPos.push(i);
    });

    function getCurrentVariant() {
      var input = document.querySelector(
        'form[action*="/cart/add"] input[name="id"], form[id^="product-form"] input[name="id"]'
      );
      if (!input) return null;
      return variants.find(function (v) { return String(v.id) === String(input.value); });
    }

    function findVariant(newColor) {
      var cv = getCurrentVariant();
      return variants.find(function (v) {
        if (colorPos >= 0 && v['option' + (colorPos + 1)] !== newColor) return false;
        for (var i = 0; i < otherPos.length; i++) {
          var pos = otherPos[i];
          var expected = cv ? cv['option' + (pos + 1)] : null;
          if (expected && v['option' + (pos + 1)] !== expected) return false;
        }
        return true;
      }) || variants.find(function (v) {
        return colorPos < 0 || v['option' + (colorPos + 1)] === newColor;
      });
    }

    function updateVariantInputs(newVariantId) {
      var variantInputs = document.querySelectorAll('input[name="id"]');
      variantInputs.forEach(function (inp) {
        var form = inp.closest('form');
        if (!form) return;
        if (inp.closest('cart-drawer, cart-notification, #cart-drawer, .cart-drawer, .mini-cart, [id*="cart-drawer"], [id*="mini-cart"]')) return;
        var action = form.action || '';
        var fid = form.id || '';
        if (action.indexOf('/cart/change') !== -1 || action.indexOf('/cart/update') !== -1) return;
        if (action.indexOf('/cart/add') !== -1 || fid.indexOf('product-form') === 0 || fid.indexOf('sticky-addcart-form') === 0) {
          inp.value = String(newVariantId);
        }
      });
    }

    function swapMedia(newVariantId) {
      var url = productUrl + '?variant=' + newVariantId + '&section_id=' + sectionId;
      var currentMedia = document.querySelector('#MainProduct-' + sectionId + ' .product-detail__media')
                     || document.querySelector('.product-detail__media');
      if (!currentMedia) { isSwapping = false; return; }

      /* Fade sutil de las imágenes actuales — no rectángulo vacío */
      currentMedia.style.transition = 'opacity 0.15s ease';
      currentMedia.style.opacity = '0.35';
      currentMedia.style.pointerEvents = 'none';

      function cleanup() {
        currentMedia.style.opacity = '1';
        currentMedia.style.pointerEvents = '';
        setTimeout(function () { currentMedia.style.transition = ''; }, 200);
        isSwapping = false;
      }

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newMedia = doc.querySelector('#MainProduct-' + sectionId + ' .product-detail__media')
                     || doc.querySelector('.product-detail__media');
          if (!newMedia) throw new Error('no newMedia in fetched HTML');

          var firstImg = newMedia.querySelector('img[src]');
          if (!firstImg) return newMedia;
          return new Promise(function (resolve) {
            var pre = new Image();
            pre.onload = pre.onerror = function () { resolve(newMedia); };
            pre.src = firstImg.getAttribute('src');
            setTimeout(function () { resolve(newMedia); }, 700);
          });
        })
        .then(function (newMedia) {
          currentMedia.innerHTML = newMedia.innerHTML;
          currentMedia.querySelectorAll('script').forEach(function (oldS) {
            var newS = document.createElement('script');
            if (oldS.type) newS.type = oldS.type;
            newS.textContent = oldS.textContent;
            oldS.parentNode.replaceChild(newS, oldS);
          });
          initMobileSlider(sectionId);

          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cleanup(); });
          });

          history.replaceState({}, '', productUrl + '?variant=' + newVariantId);
          currentVariantId = newVariantId;
          try { updateVariantInputs(newVariantId); } catch (e) { console.warn('[SB] updateInputs err', e); }
        })
        .catch(function (err) {
          console.error('[SB gallery swap error]', err);
          cleanup();
        });
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-csb-swatch]');
      if (!chip) return;
      var newColor = chip.dataset.colorValue;
      if (!newColor) return;
      if (isSwapping) return;

      setTimeout(function () {
        if (isSwapping) return;
        var match = findVariant(newColor);
        if (!match) { console.warn('[SB] no variant match for', newColor); return; }
        if (String(match.id) === String(currentVariantId)) return;
        isSwapping = true;
        swapMedia(match.id);
      }, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();